<app-performance-tab [storageKey]="storageKey" [loadStats]="loadStats">
    <ng-template let-stats let-sidenav="sidenav" let-filters="filters">
        @if (stats.meta.results) {
            <app-risk-type-stats [data]="stats.data"></app-risk-type-stats>
        } @else {
            <app-empty-state
                illustration="search"
                title="No Statistics Yet"
                message="There is no data in the selected date range and filters.">
                <a
                    class="btn-secondary"
                    (click)="sidenav.open(); $event.stopPropagation()">
                    Edit Filters
                </a>
            </app-empty-state>
        }
        @if (hazardAnalysisRequested) {
            <app-hazard-analysis [filters]="filters"></app-hazard-analysis>
        } @else {
            <div class="col-12">
                <app-card [showHeader]="false" [noMargin]="true">
                    <app-deferred-charts-promo
                        card-body
                        title="Analyze Individual Hazards"
                        description="Review charts for individual hazards to understand trends that may be occurring."
                        (loadRequested)="hazardAnalysisRequested = true">
                    </app-deferred-charts-promo>
                </app-card>
            </div>
        }
    </ng-template>
</app-performance-tab>
